import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Statistic } from 'antd';
import { format } from 'date-fns';
import currency from 'currency.js';
import { StyledStatisticGroup } from './Styles';
import { ApplicationUIContext } from '@yuhuinc/ui-library';
import { formatMoney } from 'helpers/Formatter';

const formatStatistic = (value) => {
  if (value instanceof Date) {
    return format(value, 'yyyy-MM-dd');
  }

  if (value instanceof currency) {
    return formatMoney(value);
  }

  // This way we can render `0`
  if (typeof value === 'number') {
    return value;
  }

  if (!value) {
    return '-';
  }
};

const Stats = ({ items, valueStyle }) => {
  const { isMobile } = useContext(ApplicationUIContext);

  return (
    <StyledStatisticGroup isMobile={isMobile}>
      {items.filter(Boolean).map((item) => (
        <Statistic
          key={`${item.title}.${item.value}`}
          title={item.title}
          value={item.value}
          formatter={item.formatter || formatStatistic}
          valueStyle={valueStyle}
        />
      ))}
    </StyledStatisticGroup>
  );
};

Stats.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any,
      title: PropTypes.string,
    })
  ),
};

export default Stats;
